
export default function ArrayExtends() {
    Array.prototype.distinct = function (func) {
        const ret = []
        let fn;
        if (typeof func === 'function') {
            fn = func
        } else {
            fn = function (a1, a2) {
                return a1 === a2
            }
        }
        for (const prop of this) {
            let flag = true
            for (const elm of ret) {
                if (fn(prop, elm)) {
                    flag = false
                }
            }
            if (flag) {
                ret.push(prop)
            }
        }
        return ret
    }
}
